module.exports = __webpack_public_path__ + "img/product-wiper-slider.244fc9cd.jpg";